import React from 'react';
import { RotateCcw } from 'lucide-react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from '../ui/alert-dialog';

export const ResetLimitButton = ({ onConfirm }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      <button data-testid="reset-limit-btn"
        className="inline-flex items-center gap-2 bg-blue-600 text-white px-5 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors">
        <RotateCcw size={18} /> Reset Application Limit
      </button>
    </AlertDialogTrigger>
    <AlertDialogContent data-testid="reset-limit-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>Reset the application limit?</AlertDialogTitle>
        <AlertDialogDescription>
          The count goes back to 0 and the application form reopens on the website. Existing applications are kept.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="reset-limit-cancel-btn">Cancel</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} data-testid="reset-limit-confirm-btn">Reset</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
